<template>
  <el-container>
    <!-- 主体内容 -->
    <el-header
      style="display: flex; align-items: center; justify-content: space-between"
    >
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>系统管理员列表</el-breadcrumb-item>
      </el-breadcrumb>
      <el-button-group>
        <el-button type="info" icon="el-icon-search" @click="addSuper"
          >添加管理员</el-button
        >
      </el-button-group>
    </el-header>
    <el-main>
      <!-- 查询工具栏-->
      <div class="cust_seach">
        <el-input
          class="btnTitle"
          suffix-icon="el-icon-search"
          v-model="query.queryString"
          placeholder="请输入模糊字段"
          @input="querySubmit"
        />
        <!-- <el-button-group>
          <el-button
            type="primary"
            icon="el-icon-search"
            @click="querySubmit"
          />
        </el-button-group> -->
      </div>
      <el-table :data="data.managers" style="width: 100%" ref="refManagers">
        <el-table-column
          align="left"
          property="userName"
          label="用户名"
          width="80px"
        />
        <el-table-column align="left" property="unitName" label="单位" />
        <el-table-column align="left" property="phone" label="手机号" />
        <el-table-column align="left" property="hasRoles.roles" label="角色" />
        <el-table-column align="center" label="操作" width="120">
          <span>
            <el-button
              type="primary"
              size="mini"
              icon="el-icon-edit"
            ></el-button
          ></span>
          <template slot-scope="scope">
            <span>
              <el-link icon="el-icon-edit" @click="setRoles(scope.row.userId)"
                >编辑</el-link
              >
            </span>
          </template>
        </el-table-column>
      </el-table>
      <div class="cust_pagin">
        <el-pagination
          layout="prev, pager, next"
          :total="xpagination.totalCount"
          :page-size="xpagination.pageSize"
          :current-page="xpagination.pageNumber"
          @current-change="handleCurrentChange"
          hide-on-single-page
          :background="true"
        />
      </div>
    </el-main>
  </el-container>
</template>
    
<script>
import router from "@/router/main";
export default {
  beforeRouteLeave(to, from, next) {
    this.saveStore();
    next(); // 继续后续的导航解析过程
  },
  created() {
    this.pstApi.setWindowTitle("网站参数设置");
    if (this.$store.state.supersPagins) {
      this.query = this.$store.state.supersPagins.query;
      this.xpagination = this.$store.state.supersPagins.xpagination;
    }
    this.getManagers();
  },
  data() {
    return {
      //数据项
      data: {
        units: [],
        managers: [],
      },
      //搜索栏数据
      query: {
        queryString: "", //模糊字段
      },
      //分页栏数据
      xpagination: {
        totalCount: 1,
        pageSize: 10,
        pageNumber: 1,
        totalPages: 1,
      },
    };
  },
  methods: {
    saveStore() {
      this.$store.commit("setSupersPagins", {
        query: this.query,
        xpagination: this.xpagination,
      });
    },
    getManagers() {
      //保存store
      this.saveStore();
      let queryString = this.query.queryString;
      let pageIndex = this.xpagination.pageNumber;
      let pageSize = this.xpagination.pageSize;
      // console.log(pageIndex)
      this.pstApi
        .getManagers(queryString, pageIndex, pageSize)
        .then((resp) => {
          this.data.managers = resp.data;
          //console.log(this.data.managers);
          var pagin = JSON.parse(resp.headers.xpagination);
          // console.log(pagin)
          this.xpagination.totalCount = parseInt(pagin.totalCount);
          this.xpagination.pageSize = parseInt(pagin.pageSize);
          this.xpagination.pageNumber = parseInt(pagin.currentPage);
          this.xpagination.totalPages = parseInt(pagin.totalPages);
        })
        .catch((err) => {
          var message = err.response.data.Message;
          if (message == null) {
            message = "服务器访问失败";
          }

          this.$toast(message);
        });
    },
    querySubmit() {
      this.xpagination.pageNumber = 1;
      this.getManagers();
    },
    addSuper() {
      //保存store
      this.saveStore();
      this.$router.push({ name: "AddSuper" });
    },
    setRoles(userId) {
      //保存store
      this.saveStore();
      this.$router.push({ name: "EditSuper", params: { id: userId } });
    },
    handleCurrentChange(val) {
      // console.log(val)
      this.xpagination.pageNumber = val;
      this.getManagers();
    },
  },
};
</script>
    
  <style lang="less" scoped>
.el-header {
  background-color: #b3c0d1;
  color: #333;
  line-height: 40px;
}
//工具栏样式
.cust_seach {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 50px;
  width: 100%;
  padding: auto 5px;
  .btnLeft {
    flex: 1;
    margin: 0;
    /deep/ .el-input__inner {
      height: 41px;
      border-radius: 0px;
      border-top-left-radius: 4px;
      border-bottom-left-radius: 4px;
    }
  }
  .btnTitle {
    flex: 2;
    margin: 0;
    /deep/ .el-input__inner {
      height: 41px;
      border-radius: 0px;
      border-top-left-radius: 0px;
      border-bottom-left-radius: 0px;
    }
  }
  .btnStatus {
    flex: 1;
    margin: 0;
    /deep/ .el-input__inner {
      height: 41px;
      border-radius: 0px;
      border-top-right-radius: 0px;
      border-bottom-right-radius: 0px;
    }
  }
  .el-button-group > .el-button:first-child:last-child {
    border-radius: 0px;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
  }
}
.el-select {
  float: left;
}
.cust_pagin {
  display: flex;
  position: sticky;
  bottom: 0;
  z-index: 999;
}
/deep/.el-breadcrumb__separator {
  color: rgb(87, 86, 86);
}
/deep/.el-input.is- .el-input__inner {
  color: #031944;
}
/deep/.el-textarea.is- .el-textarea__inner {
  color: #031944;
}

.headtool {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.miniTool {
  height: 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
//
.img-list {
  overflow: hidden;
  width: 100%;
  // 文件列表
  .img-li-box {
    float: left;
    text-align: left;
    position: relative;
    display: block; //Inline-block
    width: 200px;
    height: 270px;
    padding: 5px;
    margin: 5px 20px 20px 0;
    border: 1px solid #d1dbe5;
    border-radius: 4px;
    transition: all 0.3s;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12), 0 0 6px 0 rgba(0, 0, 0, 0.04);
    // 图片
    .img-li-b--url {
      display: block;
      width: 100%;
      height: 190px;
      margin: 0 auto;
      border-radius: 4px;
    }
    // 底部
    .img-li-b--bottom {
      margin-top: 10px;
      // 名称
      .img-li-b--name {
        width: 90%;
        text-overflow: ellipsis;
        overflow: hidden;
        height: 25px;
        line-height: 25px;
      }
    }
    // 删除按钮
    .img-li-b--delete {
      position: absolute;
      bottom: 10px;
      right: 10px;
      color: #8492a6;
      cursor: pointer;
      font-size: 1.1em;
    }
    // 放大遮罩层
    .img-li-b--layer {
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      height: 200px;
      color: #fff;
      text-align: center;
      z-index: 5;
      background-color: rgba(0, 0, 0, 0.4);
      // 放大按钮
      i {
        font-size: 1.6em;
        margin-top: 80px;
      }
    }
    .img-li-b--delete,
    .img-li-b--layer {
      opacity: 0;
      transition: all 0.3s;
    }
    // 悬浮可见删除 or 放大按钮
    &:hover {
      .img-li-b--delete,
      .img-li-b--layer {
        opacity: 1;
      }
    }
    // 上传进度
    &.img-li-b--progress {
      // padding: 0;
      // text-align: center;
      // padding-top: 0px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  // 上传按钮
  .img-li-b--upload {
    float: left;
    width: 200px;
    height: 270px;
    display: table;
    text-align: center;
    .img-li-b--upl--field {
      width: 100%;
      display: table-cell;
      vertical-align: middle;
    }
  }
}
.el-dialog-div {
  margin: 0 auto;
  height: 500px;
  overflow: auto;
  display: flex;
  align-items: center;
}

/deep/ .el-drawer__body {
  overflow-y: none;
  padding: 5px 5px;
  margin-bottom: 50px;
}

.demo-drawer__footer {
  width: 100%;

  position: absolute;
  bottom: 0;
  left: 0;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: center;
  background-color: white;
  .el-button {
    flex: 1;
  }
}
</style>